var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM367.915,198.646c.3,19.091-2.227,114.546-92.824,155.909S116,344.374,116,344.374c50.676,4.772,83.915-23.864,83.915-23.864-41.046-1.75-52.978-39.932-52.978-39.932,14.637,2.546,24.765-1.538,24.765-1.538-45.817-12.3-44.651-56.848-44.651-56.848,13.045,7.742,24.5,6.363,24.5,6.363-42.424-30.545-16.46-76.045-16.46-76.045,47.727,58.864,119.22,60.506,119.22,60.506a67.027,67.027,0,0,1-1.493-14.37c0-38.181,33.642-57.272,57.273-57.272s41.119,17.818,41.119,17.818c17.978-.8,37.228-13.046,37.228-13.046-7.637,23.228-23.7,31.819-23.7,31.819,14.557-1.591,31.267-8.91,31.267-8.91C390.358,181.465,367.915,198.646,367.915,198.646Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.74cad1f05ea7967e7b716ee7f4f50683.svg";
export { ForwardRef as ReactComponent };